export const SPARTAN_MEDIA_DEFAULT_IMAGE_DURATION_MS = 6000;

export const normalizeMediaProgress = (
  currentTime: number,
  duration: number
): number => {
  if (!Number.isFinite(currentTime) || !Number.isFinite(duration)) return 0;
  if (duration <= 0) return 0;

  return Math.min(1, Math.max(0, currentTime / duration));
};
